import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { useConfig, goToCheckout } from "@/lib/useConfig";

// Botão de compra reutilizável. Redireciona para CHECKOUT_URL se configurado.
export function BuyButton({
  label = "QUERO ACESSAR POR R$ 4,99",
  source = "cta",
  className = "",
  size = "lg",
  testId = "buy-button",
}) {
  const { config } = useConfig();

  const handleClick = () => {
    const ok = goToCheckout(config, source);
    if (!ok) {
      toast.info("Checkout em configuração", {
        description:
          "O link de compra ainda será configurado. Defina a variável CHECKOUT_URL para ativar o pagamento.",
      });
    }
  };

  return (
    <Button
      onClick={handleClick}
      size={size}
      data-testid={testId}
      className={`group h-auto rounded-full bg-emerald-500 px-7 py-4 text-base font-bold text-slate-950 shadow-[0_0_30px_rgba(16,185,129,0.35)] transition-all hover:bg-emerald-400 hover:scale-[1.02] active:scale-95 ${className}`}
    >
      {label}
      <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
    </Button>
  );
}
